import { Box, Grid, InputLabel, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface WebsiteFormUIProps {
  localValue: string;
  onChange: (value: string) => void;
  onBlur: () => void;
}

const WebsiteFormUI: React.FC<WebsiteFormUIProps> = ({ localValue, onChange, onBlur }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            value={localValue}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default WebsiteFormUI;
